import { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

/**
* Renders a themed skeleton placeholder for the recent activity component.
* @example
* RecentACSkeleton()
* <div className="rounded-lg shadow-sm p-6">...</div>
* @param {void} props - No props are used.
* @returns {JSX.Element} The skeleton layout for recent activity tabs and list items.
**/
const RecentACSkeleton = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div 
      className="rounded-lg shadow-sm p-6"
      style={{ 
        backgroundColor: theme.background.card,
        boxShadow: theme.shadow.md
      }}
    >
      {/* Tab skeleton */}
      <div 
        className="flex gap-4 mb-4"
        style={{ borderBottom: `1px solid ${theme.border.primary}` }}
      >
        {[1, 2, 3, 4].map((i) => (
          <div 
            key={i} 
            className="h-8 w-24 rounded animate-pulse mb-2"
            style={{ backgroundColor: theme.background.secondary }}
          />
        ))}
      </div>
      
      {/* List skeleton */}
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <div 
            key={i} 
            className="flex justify-between items-center py-2"
            style={{ borderBottom: `1px solid ${theme.border.subtle}` }}
          >
            <div 
              className="h-5 rounded w-48 animate-pulse"
              style={{ backgroundColor: theme.background.secondary }}
            />
            <div 
              className="h-4 rounded w-20 animate-pulse"
              style={{ backgroundColor: theme.background.secondary }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentACSkeleton;
